import React from 'react';
import PropTypes from 'prop-types';
import './icon.scss';

const Icon = ({ iconName, children }) => {
  const classes = iconName ? `icon icon__${iconName}` : '';

  return (
    <div className={classes}>{children}</div>
  );
};

Icon.propTypes = {
  iconName: PropTypes.string,
  children: PropTypes.string
};

Icon.defaultProps = {
  iconName: null,
  children: 'Icon'
};

export default Icon;